import assign = require('object-assign');
import { 
    FETCH_JOBS_REQUEST, 
    FETCH_JOBS_SUCCESS, 
    FETCH_JOBS_FAILURE,
    FETCH_SYSTEMS_WITH_JOBS_REQUEST, 
    FETCH_SYSTEMS_WITH_JOBS_SUCCESS, 
    FETCH_SYSTEMS_WITH_JOBS_FAILURE,
} from '../../constants/PM';

import { IWidgetDataState } from '../../interfaces/states';

const initialState = {};

export function isResponsible(action) {
    switch(action.type) {
        case FETCH_JOBS_REQUEST:
        case FETCH_JOBS_SUCCESS:
        case FETCH_JOBS_FAILURE:
        case FETCH_SYSTEMS_WITH_JOBS_REQUEST:
        case FETCH_SYSTEMS_WITH_JOBS_SUCCESS:
        case FETCH_SYSTEMS_WITH_JOBS_FAILURE:
            return true;
        default:
            return false;
    }
}

function formatDate(job, key) {
    if (job[key]) {
        job[key] = new Date(job[key]);
    }
    return job;
}

function formatJob(job) {
    formatDate(job, 'PlannedStartTime');
    formatDate(job, 'StartTime');
    formatDate(job, 'EndTime');

    return job;
}

function formatJobs(jobs) {
    if(Array.isArray(jobs)) {
        jobs.forEach(formatJob);
        return jobs;
    }

    Object.keys(jobs).forEach(key => {
        jobs[key].forEach(formatJob);
    });

    return jobs;
}

export default function systems(state = initialState, action): IWidgetDataState {
    switch (action.type) {
        case FETCH_SYSTEMS_WITH_JOBS_REQUEST:
        case FETCH_JOBS_REQUEST: {
            return assign({}, state, {
                jobs: {
                    loading: true
                }
            });
        }
        case FETCH_SYSTEMS_WITH_JOBS_SUCCESS: {
            return assign({}, state, {
                jobs: {
                    loading: false,
                    data: formatJobs(action.payload.jobs)
                }
            });
        }
        case FETCH_JOBS_SUCCESS: {
            return assign({}, state, {
                jobs: {
                    loading: false,
                    data: formatJobs(action.payload)
                }
            });
        }
        case FETCH_SYSTEMS_WITH_JOBS_FAILURE:
        case FETCH_JOBS_FAILURE: {
            return assign({}, state, {
                jobs: {
                    loading: false,
                    error: action.error,
                    data: action.payload
                }
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/widgetData/jobs.ts